import React from 'react';
import { useToast, Toast, ToastType } from '../../contexts/ToastContext';
import styles from './toast.module.css';

const ICONS: Record<ToastType, React.ReactNode> = {
  success: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5"/><path d="M6.5 10.2l2.3 2.3 4.7-4.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  error:   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5"/><path d="M7.5 7.5l5 5M12.5 7.5l-5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>,
  info:    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5"/><path d="M10 9v5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/><circle cx="10" cy="6.3" r="1" fill="currentColor"/></svg>,
  warning: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M8.7 3.4a1.5 1.5 0 0 1 2.6 0l6 10.6a1.5 1.5 0 0 1-1.3 2.2H4a1.5 1.5 0 0 1-1.3-2.2l6-10.6z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M10 8v3.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/><circle cx="10" cy="13.8" r="0.9" fill="currentColor"/></svg>,
};

const ToastItem: React.FC<{ toast: Toast; onClose: (id: string) => void }> = ({ toast, onClose }) => {
  const [hiding, setHiding] = React.useState(false);

  const handleClose = React.useCallback(() => {
    setHiding(true);
    setTimeout(() => onClose(toast.id), 250); // длительность slideOut
  }, [onClose, toast.id]);

  return (
    <div
      className={`${styles.toast} ${styles[toast.type]} ${hiding ? styles.hiding : ''}`}
      role="alert"
    >
      <span className={styles.icon}>{ICONS[toast.type]}</span>
      <span className={styles.message}>{toast.message}</span>
      <button className={styles.close} onClick={handleClose} aria-label="Закрыть">×</button>
      {toast.duration > 0 && (
        <span
          className={styles.progress}
          style={{ '--duration': `${toast.duration}ms` } as React.CSSProperties}
        />
      )}
    </div>
  );
};

const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className={styles.container}>
      {toasts.map(t => (
        <ToastItem key={t.id} toast={t} onClose={removeToast} />
      ))}
    </div>
  );
};

export default ToastContainer;